<template>
    <div>
        <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>
        
        <div class="row">
            <div class="col-1" style="padding-top: 8px">
                <div
                    class="container-butacas animated fadeInLeft text-align-center"
                >
                    <div
                        v-for="(fila, index_fila) in filas"
                        :key="index_fila"
                        class="butaca filav"
                    >
                        <strong>
                            <span class="font-weight-bold">{{ fila.alias }}</span>
                        </strong>
                    </div>
                </div>
            </div>
            <div class="col-11">
                <div
                    class="margin-responsive container-butacas-wrapper scroll-smooth mb-2 p-2"
                    v-if="!loading"
                    ref="butacasWrapper"
                >
                    <div
                        :class="
                            'container-butacas animated fadeInLeft text-align-' +
                                zona.print_align
                        "
                    >
                        <template v-for="(fila, index_fila) in filas">
                            <span :key="index_fila">
                                <template v-for="(asiento, index) in ordenarButacas(fila.asientos)">
                                    <AsientoComponent :asiento="asiento" :fila="fila.alias" :front="true" :key="index+'_2'" @toggle="() => toggleSeleccion(asiento)"/>
                                </template>
                            </span>
                        </template>
                    </div>
                </div>
                <template v-else>
                    <LoaderComponent/>
                </template>
            </div>
        </div>

        <LeyendaButacasComponent/>
    </div>
</template>

<script>
    import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";
    import TerrenoJuegoComponent from '@/components/common/Asientos/TerrenoJuegoComponent.vue';
    import LeyendaButacasComponent from '@/components/common/Asientos/LeyendaButacasComponent.vue'
    import comprobarButacasLFP from "@/mixins/comprobarButacasLFP";

    export default {
        props: ['zona', 'asientos', 'asientos_maximos', 'puedo_cambiar', 'forzar_adyacentes', 'event'],
        data() {
            return {
                loading: true,
                filas: null,
                datos_compradores: [],
                precios: null,
                last_row: null
            }
        },
        mixins: [comprobarButacasLFP],
        created() {
            this.getZona(this.zona.id);
        },
        watch : {
            zona() {
                this.getZona(this.zona.id);
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            getZona(id) {
                this.loading = true;
                var params = null;
                if(this.$route.params.event_id != undefined && this.$route.params.sesion_id != undefined) {
                    params = {
                        filters: {
                            zona_id: id,
                            conf: true,
                            evento_id: this.$route.params.event_id,
                            sesion_id: this.$route.params.sesion_id,
                            tid: this.configuracion.hash_teatro
                        },
                        zona_id: id,
                    };
                } else {
                    params = {
                        filters: {
                            zona_id: id,
                            conf: true
                        },
                    };
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.show'), params).then(res => {
                    this.filas = res.data.data.configuracion;
                    this.precios = res.data.data.precios;
                    this.loading = false;
                    this.$emit('cargado');
                });                
            },
            toggleSeleccion : function(asiento) {
                if(this.puedo_cambiar && asiento.ocupado == false) {
                    if(asiento.seleccionado) {
                        for(var j in this.asientos) {
                            if(this.asientos[j].asiento.fila == asiento.fila && this.asientos[j].asiento.asiento == asiento.asiento) {
                                this.asientos.splice(j, 1);
                            }
                        }
                        asiento.seleccionado = false;
                    } else {
                        if(this.asientos.length < (this.asientos_maximos ? this.asientos_maximos : 15)) {
                            var data = {
                                'asiento' : {
                                    fila : asiento.fila,
                                    asiento : asiento.asiento,
                                    zona_id : this.zona.id,
                                    zona_nombre : this.zona.name,
                                    seat_id: asiento.seat_id
                                },

                                nombre : '',
                                apellidos : '',
                                dni : '',
                                telefono : '',
                                precios : this.precios,
                                url_imprimir : null,
                                es_nuevo : true,
                                precio: this.precios[0]
                            }

                            this.asientos.push(data);
                            asiento.seleccionado = true;
                        } else {
                            this.$toast.error(this.$t('eventos.error_limite_asientos') + ' (Máx: ' + this.asientos_maximos + ')');
                        }
                    }
                    this.actualizarDatos();
                }

                var valido = true;

                if(this.event && this.event.comprobacion_butacas){
                    valido =  this.comprobarButacasLFP(this.filas)
                }

                this.$emit('validoAsientos' , valido);

                this.$emit('changeAnySelected', this.datos_compradores.length !== 0);
            },
            actualizarDatos() {
                this.$emit('actualizarDatos', this.datos_compradores);
            },
            esConfiguracionAsientosValida() {
                if(!this.forzar_adyacentes) {
                    return true;
                }

                for(var fila in this.filas) {
                    for(var i in this.filas[fila]) {
                        if(i == 0) continue;

                        let actual = this.filas[fila][i];
                        let anterior = this.filas[fila][i-1];
                        if((actual.seleccionado && !anterior.seleccionado && !anterior.ocupado) ||
                            (anterior.seleccionado && !actual.seleccionado && !actual.ocupado)) {
                            return false;
                        }
                    }
                }
                return true;
            },
            scrollLeft() {
                this.$refs["butacasWrapper"].scrollBy(-this.$refs["butacasWrapper"].parentElement.scrollWidth, 0)
            },
            scrollRight() {
                this.$refs["butacasWrapper"].scrollBy(this.$refs["butacasWrapper"].parentElement.scrollWidth, 0)
            },
            ordenarButacas(butacas) {
                const keys = Object.keys(butacas).reverse();

                const array = [];

                keys.forEach(key => {
                    array.push(butacas[key]);
                })

                return array;
            }
        },
        components: {
            AsientoComponent, TerrenoJuegoComponent, LeyendaButacasComponent
        }
    }
</script>

<style>
    .filav {
        font-size: 10px;
    }

    @media screen and (max-width: 600px) {
        .margin-responsive {
            left: -8px;
        }
    }

    @media screen and (min-width: 1200px) {
        .margin-responsive {
            left: -25px;
        } 
    }
</style>